module.exports = __webpack_public_path__ + "static/media/tires_icon.ffbe15ae.png";